import { render, staticRenderFns } from "./NotificationCreatorServicePurchase.vue?vue&type=template&id=002d5b1c&scoped=true&"
import script from "./NotificationCreatorServicePurchase.vue?vue&type=script&lang=ts&"
export * from "./NotificationCreatorServicePurchase.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationCreatorServicePurchase.vue?vue&type=style&index=0&id=002d5b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002d5b1c",
  null
  
)

export default component.exports